// getLivestreamComputedData.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

/**
 * Select whether the livestream has a valid stream token.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - livestream id.
 * @return {boolean} True if the livestream has either byteplusToken or streamToken.
 */
const geHasStreamToken = createCachedSelector(
  (state, streamId) =>
    getOperationData(state, ['liveStream', 'paid', streamId], 'byteplusToken'),
  (state, streamId) =>
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken'),
  (streamToken, byteplusToken) => !!(streamToken || byteplusToken)
)((state, streamId) => `${streamId}`);

/**
 * Select whether the livestream has any toy device online.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - livestream id.
 * @return {boolean} True if there is at least one device online.
 */
const getIsToyDeviceOnline = createCachedSelector(
  (state, streamId) => getLiveStreamData(state, [streamId], 'device'),
  devices => !!devices && Object.keys(devices).length > 0
)((state, streamId) => `${streamId}`);

export { geHasStreamToken, getIsToyDeviceOnline };
